<template>
  <div>
    <AppWithLoading :fetch="fetch" :key="fetchKey" v-slot:default="{loader}">
      <template v-if="vacancies.length">
        <div class="vacancy-list-detail">
          <VacanciesListDetailListItem
            @excluded="$emit('excluded',$event)"
            v-for="vacancy in vacancies"
            :key="vacancy.id"
            :vacancy="vacancy"
          />
          <template v-if="metaData && vacancies && metaData.lastPage > 1">
            <VPagination
              :value="currentPage"
              @input="loader(()=> loadPage($event))"
              :length="metaData.lastPage"
              class="pt-5"
            />
          </template>
        </div>
      </template>
      <template v-else>
        {{ $t('empty') }}
      </template>
    </AppWithLoading>
  </div>
</template>

<script>
import useVacanciesList from '@/compositions/useVacanciesList';
import AppWithLoading from '@/components/AppWithLoading';
import { computed, ref, toRefs } from '@vue/composition-api';
import VacanciesListDetailListItem from '@/components/VacancyLists/VacanciesListDetailListItem';

export default {
  name: 'VacanciesListDetailList',
  components: { VacanciesListDetailListItem, AppWithLoading },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { value } = toRefs(props);
    const currentPage = ref(1);
    const { fetchVacancies, vacancies, metaDataVacancies } = useVacanciesList();

    async function fetch(page = 1) {
      await fetchVacancies({ ...value.value, perPage: 20, page });
    }

    async function loadPage(page) {
      await fetch(page);
      currentPage.value = page;
    }

    return {
      fetch,
      loadPage,
      vacancies,
      fetchKey: computed(() => JSON.stringify(value)),
      metaData: metaDataVacancies,
      currentPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-detail {
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  padding: 1.125rem 2.5rem 1.875rem 2.5rem;
  margin-bottom: 1.25rem;
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .vacancy-list-detail {
    padding: 1.5rem 1.75rem;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .vacancy-list-detail {
    padding: 1.375rem 1rem;
  }
}
</style>

<i18n lang="yml" locale="ru">
empty: По заданным условиям вакансий не найдено
</i18n>
<i18n lang="yml" locale="en">
empty: No jobs found
</i18n>
